import React, { useState, useEffect } from "react";
import { api, formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";
import { MessageSquare, Star, Reply, Send } from "lucide-react";

export function GuestReviews() {
  const [reviews, setReviews] = useState([]);
  const [replyFor, setReplyFor] = useState(null);
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try { const { data } = await api.get("/host/reviews"); setReviews(data); } catch { /* noop */ }
  };
  useEffect(() => { load(); }, []);

  const sendReply = async (review_id) => {
    if (!text.trim()) { toast.error("Write a reply first"); return; }
    setSaving(true);
    try {
      await api.post(`/reviews/${review_id}/reply`, { reply: text });
      toast.success("Reply posted");
      setReplyFor(null); setText(""); load();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message); }
    finally { setSaving(false); }
  };

  return (
    <div className="rounded-2xl border border-border bg-card p-6" data-testid="guest-reviews-panel">
      <div className="flex items-center gap-2 mb-5"><MessageSquare size={18} /><h2 className="font-display text-xl font-medium">Guest Reviews</h2></div>
      {reviews.length === 0 ? (
        <p className="text-sm text-muted-foreground">No reviews yet. They'll appear here once guests rate your hotspots.</p>
      ) : (
        <div className="space-y-3" data-testid="host-reviews-list">
          {reviews.map((r) => (
            <div key={r.review_id} className="rounded-xl border border-border p-4">
              <div className="flex items-center justify-between mb-1">
                <span className="text-sm font-medium">{r.guest_name || "Member"} <span className="text-muted-foreground font-normal">· {r.hotspot_name}</span></span>
                <span className="flex gap-0.5">{[1, 2, 3, 4, 5].map((n) => <Star key={n} size={12} className={n <= r.rating ? "fill-amber-400 text-amber-400" : "text-muted-foreground"} />)}</span>
              </div>
              {r.comment && <p className="text-sm text-muted-foreground">{r.comment}</p>}
              {r.host_reply ? (
                <div className="mt-2 pl-3 border-l-2 border-emerald-500/50">
                  <p className="text-xs text-muted-foreground"><span className="font-medium text-foreground">Your reply:</span> {r.host_reply}</p>
                </div>
              ) : replyFor === r.review_id ? (
                <div className="mt-3">
                  <textarea value={text} onChange={(e) => setText(e.target.value)} rows={2} placeholder="Write a public reply…" data-testid={`reply-input-${r.review_id}`}
                    className="w-full px-3 py-2 rounded-lg bg-background border border-input text-sm outline-none focus:border-ring resize-none mb-2" />
                  <div className="flex gap-2">
                    <button onClick={() => sendReply(r.review_id)} disabled={saving} data-testid={`send-reply-${r.review_id}`} className="h-9 px-4 rounded-lg bg-foreground text-background text-sm font-medium flex items-center gap-1 hover:opacity-90 transition-opacity disabled:opacity-50"><Send size={13} /> Post</button>
                    <button onClick={() => { setReplyFor(null); setText(""); }} className="h-9 px-4 rounded-lg border border-border text-sm">Cancel</button>
                  </div>
                </div>
              ) : (
                <button onClick={() => { setReplyFor(r.review_id); setText(""); }} data-testid={`reply-btn-${r.review_id}`} className="mt-2 text-xs text-muted-foreground hover:text-foreground flex items-center gap-1"><Reply size={13} /> Reply</button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
